// Billing policies (docs/billing.md). A tenant's billing state, checkout and portal are that
// tenant's own resources and the TenantAdmin's to operate: Managers and Agents never see
// invoices or start a payment. Subscription operations belong to platform staff. The Stripe
// webhook is public by design: Stripe authenticates with a signature, there is no principal.
import { always, isRole, platformAdmin } from '../policy/rules.js';
const tenantAdmin = isRole('TenantAdmin');
export const billingPolicy = {
    kind: 'billing',
    scope: 'tenant',
    actions: { read: tenantAdmin },
};
export const checkoutPolicy = {
    kind: 'checkout',
    scope: 'tenant',
    actions: { create: tenantAdmin },
};
export const portalPolicy = {
    kind: 'portal',
    scope: 'tenant',
    actions: { create: tenantAdmin },
};
export const subscriptionPolicy = {
    kind: 'subscription',
    scope: 'platform',
    actions: { list: platformAdmin, read: platformAdmin, adjust: platformAdmin },
};
/** Signature-authenticated by Stripe; the edge throttles it. Open by design. */
export const webhookPolicy = {
    kind: 'webhook',
    scope: 'public',
    actions: { receive: always },
};
//# sourceMappingURL=billing.js.map